import {Card, Input} from "antd";
import Logo from '../../components/Logo';
import {QuestionCircleOutlined} from "@ant-design/icons";

const {Search} = Input
const CheckAuthenticity = () => {
    return (
        <div style={{
            width: '100vw',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#f9f9f9'
        }}>
            <Card style={{
                width: '70vw',
                height: '80px',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '10px 20px',
                borderRadius: '12px',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                border: '1px solid #ddd',
                marginTop: '24px'
            }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '15px',
                    width: '100%',
                }}>
                    <div style={{
                        flexShrink: 0,
                        display: 'flex',
                        alignItems: 'center',
                        width: '110px'
                    }}>
                        <Logo/>
                    </div>
                    <Search
                        placeholder="Search for certificates..."

                        style={{
                            flexGrow: 1,
                            borderRadius: '8px',
                            padding: '8px 12px',
                            boxShadow: 'inset 0 1px 3px rgba(0, 0, 0, 0.1)',
                            transition: 'box-shadow 0.3s ease',
                            width: '500px',
                            height: '100%'
                        }}
                        onFocus={(e) => {
                            e.target.style.boxShadow = '0 0 6px rgba(0, 123, 255, 0.5)';
                        }}
                        onBlur={(e) => {
                            e.target.style.boxShadow = 'inset 0 1px 3px rgba(0, 0, 0, 0.1)';
                        }}
                    />
                    <div>
                        <QuestionCircleOutlined/>
                    </div>
                </div>
            </Card>
        </div>
    );
};

export default CheckAuthenticity;
